"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const prop_types_1 = __importDefault(require("prop-types"));
const classnames_1 = __importDefault(require("classnames"));
const discount_label_module_scss_1 = __importDefault(require("./discount-label.module.scss"));
const pattern_library_components_svg_sprite_1 = require("@saatva-bits/pattern-library.components.svg-sprite");
const DISCOUNT_TYPES = {
    value: 'value',
    surplus: 'surplus',
    included: 'included',
    sitewide: 'sitewide'
};
const DiscountLabel = ({ text, discountType, theme, amount }) => {
    const spriteClasses = (0, classnames_1.default)(discount_label_module_scss_1.default.icon, {
        [discount_label_module_scss_1.default[`icon--${theme}`]]: !!theme && discountType === DISCOUNT_TYPES.sitewide
    });
    return ((0, jsx_runtime_1.jsxs)("div", { className: discount_label_module_scss_1.default.wrapper, children: [(0, jsx_runtime_1.jsx)(pattern_library_components_svg_sprite_1.SvgSprite, { className: spriteClasses, spriteID: 'icon-discount-single' }), (0, jsx_runtime_1.jsx)("span", { children: text }), amount && (0, jsx_runtime_1.jsx)("span", { className: discount_label_module_scss_1.default.amount, children: amount })] }));
};
DiscountLabel.propTypes = {
    /** Text for the DiscountLabel */
    text: prop_types_1.default.string.isRequired,
    /** The type of discount to display, aligned with values returned by the promotion service */
    discountType: prop_types_1.default.oneOf(Object.keys(DISCOUNT_TYPES)),
    /** The theme of the current promotion, directly from the promotion context. This styling will only apply to the `sitewide` discount type. */
    theme: prop_types_1.default.string,
    /** The amount of the discount to display. Displays string directly as provided, so may be used for percentage, dollars, etc. */
    amount: prop_types_1.default.string
};
exports.default = DiscountLabel;
//# sourceMappingURL=discount-label.js.map